import React, { useContext } from 'react';
import { MenuContext } from "../../context/MenuContext.js";
import { SettingsContext } from "../../context/SettingsContext.js";
import { useInputKeyDownHandling } from "../../hooks/useInputKeyDownHandling.js";
import { FolderButtonConnected } from "../FolderButton/FolderButton.js";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export function ContextMenuColumnTarget({
  children,
  folderItem,
  active
}) {
  const {
    externalSearch,
    rightClickTrigger
  } = useContext(SettingsContext);
  const {
    refs,
    getReferenceProps,
    isOpen,
    parent,
    setIsOpen
  } = useContext(MenuContext);
  const {
    onKeyDown,
    onClick
  } = getReferenceProps(parent?.getItemProps());
  const inputKeyDown = useInputKeyDownHandling(onKeyDown);
  const onContextMenu = e => {
    if (rightClickTrigger) {
      setIsOpen(o => !o);

      // Overwrite the set-position
      refs?.setPositionReference({
        getBoundingClientRect() {
          return {
            width: 0,
            height: 0,
            x: e.clientX,
            y: e.clientY,
            top: e.clientY,
            right: e.clientX,
            bottom: e.clientY,
            left: e.clientX
          };
        }
      });

      // prevent default opening the browser context menu
      e.preventDefault();
      return false;
    }
  };

  // Special handling for external search
  if (children && externalSearch) {
    return children((externalChildrenProps = {}) => {
      return {
        ...externalChildrenProps,
        ref: refs?.setReference,
        onKeyDown: e => {
          externalChildrenProps?.onKeyDown?.(e);
          inputKeyDown(e);
        },
        onClick: e => {
          externalChildrenProps?.onClick?.(e);
          if (!isOpen && !rightClickTrigger) {
            onClick(e);
          }
        },
        onContextMenu
      };
    });
  }

  // Standard handling for other elements (button etc.)
  if (children) {
    return children((externalChildrenProps = {}) => {
      return {
        ...externalChildrenProps,
        ref: refs?.setPositionReference,
        onKeyDown: e => {
          externalChildrenProps.onKeyDown?.(e);
          onKeyDown?.(e);
        },
        ...(rightClickTrigger ? {
          onMouseDown: () => void 0,
          onClick: externalChildrenProps.onClick,
          onContextMenu
        } : {
          onClick: e => {
            externalChildrenProps.onClick?.(e);
            onClick?.(e);
          }
        })
      };
    });
  }

  // Default handling if there are no children
  return refs && folderItem ? /*#__PURE__*/_jsx(FolderButtonConnected, {
    folderItem: folderItem,
    active: active ?? false,
    isOpen: isOpen,
    getReferenceProps: getReferenceProps,
    refs: refs
  }) : /*#__PURE__*/_jsx(_Fragment, {});
}